var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-table',{attrs:{"items":_vm.items,"title-table":'Últimas Alertas',"loading":_vm.loading,"per-page":3},on:{"update:loading":function($event){_vm.loading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }